'use client';
import { BASE_FILE_URL } from '@/common/constants';
import React from 'react';
import get from 'lodash/get';
import Image from 'next/image';

const Footer = ({ locale, footerSystems }) => {
  const footerSystem = get(footerSystems, 'results[0]');
  if (!footerSystem) return null;
  return (
    <div className="relative text-[#000000B2] py-7.5 px-2.5 min-w-51.75 container">
      <Image
        src={BASE_FILE_URL + '/' + footerSystem?.fileUrl}
        alt="footer-bg"
        className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        fill
        quality={85}
      />
      <div className="relative space-y-2 text-sm w-full flex flex-col lg:flex-row lg:justify-between">
        <div className="w-full lg:w-2/3">
          <div className="space-y-1" dangerouslySetInnerHTML={{ __html: locale === 'vi' ? footerSystem?.orgName : footerSystem?.orgNameEn }} />
          <div className="space-y-1" dangerouslySetInnerHTML={{ __html: locale === 'vi' ? footerSystem?.content : footerSystem?.contentEn }} />
        </div>
        <div className="w-full lg:w-1/3 flex justify-center items-center mt-4 lg:mt-0 mb-4 lg:mb-0">
          <a
            href="https://tinnhiemmang.vn/danh-ba-tin-nhiem/van-phong-doan-dbqh-va-hdnd-tinh-ninh-binh-1626409153"
            rel="noopener noreferrer"
            target="_blank">
            <img alt="Chứng nhận tín nhiệm mạng" src="/chung-nhan.png" width="200px" height="auto" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
